<div class="action" (click)="flyTo()" [matTooltip]="lngLat">

  <button mat-icon-button>
    <mat-icon>place</mat-icon>
  </button>
  <ng-content></ng-content>

</div>
